import { highlightStyles } from '@/components/text-editor/plugins/highlight/types';

export const COLORS = Object.entries(highlightStyles).map(([name, style]) => ({
  name: name,
  bgColor: style.backgroundColor,
  borderColor: style.borderBottom,
}));
